var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1029.05 337.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #016696;\r\n      }\r\n\r\n      .cls-3 {\r\n        letter-spacing: -.02em;\r\n      }\r\n\r\n      .cls-4 {\r\n        letter-spacing: .02em;\r\n      }\r\n\r\n      .cls-5 {\r\n        letter-spacing: -.11em;\r\n      }\r\n\r\n      .cls-6 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #676767;\r\n        font-family: SourceSansRoman-Light, 'Source Sans Variable';\r\n        font-size: 22.65px;\r\n        font-variation-settings: 'wght' 300;\r\n        font-weight: 300;\r\n      }\r\n\r\n      .cls-8 {\r\n        letter-spacing: -.02em;\r\n      }\r\n\r\n      .cls-9 {\r\n        letter-spacing: -.02em;\r\n      }\r\n\r\n      .cls-10 {\r\n        letter-spacing: -.01em;\r\n      }\r\n\r\n      .cls-11, .cls-12 {\r\n        fill: #f8a918;\r\n      }\r\n\r\n      .cls-13 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-14 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-2, .cls-12 {\r\n        font-family: Beckan-Regular, Beckan;\r\n        font-size: 99.64px;\r\n      }\r\n\r\n      .cls-15 {\r\n        letter-spacing: -.09em;\r\n      }\r\n\r\n      .cls-16 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-17 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-18 {\r\n        letter-spacing: -.01em;\r\n      }\r\n\r\n      .cls-19 {\r\n        letter-spacing: -.08em;\r\n      }\r\n\r\n      .cls-20 {\r\n        letter-spacing: 0em;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CoverPage"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(0 158.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 56.5,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 106.71,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 134.91,
    y: 0
  }, "adigm")), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(722.17 157.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 56.4,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 83.9,
    y: 0
  }, "udi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 213.32,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 265.34,
    y: 0
  }, "s")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(482.84 331.15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 0,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 8.56,
    y: 0
  }, "Working with the "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 167.37,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 173.94,
    y: 0
  }, "alen"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 213.42,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 220.24,
    y: 0
  }, "ed "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 248.04,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 254.85,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 266.95,
    y: 0,
    xmlSpace: "preserve"
  }, " c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 281.65,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 288.61,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 299.21,
    y: 0
  }, "at"), /*#__PURE__*/React.createElement("tspan", {
    x: 316.9,
    y: 0
  }, "e the unimagina"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 465,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 477.25,
    y: 0
  }, "le"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 493.56,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 496.68,
    y: 0
  }, "\u201D")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Our_Style",
    "data-name": "Our Style"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rules"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512.19,24.49h0s9.46,14.31,9.46,14.31l.06.16,75.35,186.25,5.5,12.21c1.86,4.13-.93,8.8-5.69,9.49-2.87.42-5.57.79-6.68.89-4.83.43-9.7.65-14.56.65-2.47,0-4.93-.06-7.38-.17-6.93-.32-13.9-1.1-20.73-2.31-2.81-.5-12.38-2.82-12.38-2.82,0,0,3.66-5.97,4.41-8.4l3.14-10.17c-12.24-3.2-23.71-8.11-34.16-14.59l-7.29,8.89c-1.68,2.05-6.33,8.14-6.33,8.14,0,0-6.43-4.84-8.66-6.42-5.49-3.91-10.68-8.2-15.42-12.75-4.81-4.62-9.26-9.61-13.22-14.83-1.59-2.09-5.43-8.79-5.43-8.79,0,0,6.36-2.81,8.86-4.07l11.7-5.89c-5.8-9.64-9.77-20-11.82-30.83-.02-.09-.03-.19-.05-.28l-14.06,2.03c-2.81.41-10.05,1.66-10.05,1.66,0,0-1.63-7.11-1.93-9.59-.76-6.46-.96-12.94-.58-19.25.36-6.05,1.25-12.13,2.63-18.06.57-2.45,2.82-8.85,2.82-8.85,0,0,7.24,1.24,10.03,1.89l14.89,3.5c3.66-10.26,9.14-19.9,16.3-28.71l-13.06-8.16c-2.34-1.46-8.58-5.02-8.58-5.02,0,0,4.79-6.12,6.6-8.07,4.47-4.79,9.37-9.32,14.59-13.47,4.3-3.42,8.88-6.63,13.64-9.56,2.11-1.3,4.72-1.71,7.2-1.21l10.86,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M575.99.13c-14.8.53-35.68,3.69-51.29,10.92-5.26,2.44-7.71,5.36-7.57,6.3.78,5.28,12.58,17.53,12.58,17.53,32.55-14.43,88.12-9.22,89.27,22,1.55,42.13-63.26,37.83-28.81,129.39,2.57,6.84,16.71,39.65,21.6,52.7.54,1.45,3.36,1.37,3.14-.16-5.22-36.39-20.3-79.5,4.66-104.59,8.37-8.41,20.53-15.33,33.57-22.43,30.29-16.52,33.85-54.63,22.96-73.22C660.99,12.8,623.25-1.56,575.99.13Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpLogo);
export default __webpack_public_path__ + "static/media/lp_logo.c407cf85708d93be8ce2013c75fbd3d4.svg";
export { ForwardRef as ReactComponent };